import { LobbyImage, DiceSettingEnum } from '@colonist/types';
import { UIComponentItemScroll } from '../../ui_components/item_scroll/UIComponentItemScroll.ts';
import { notificationController, socket } from '../../EntryShared.ts';
import { showRulesInfoDialog } from '../../ui_popup/showRulesInfoDialog.ts';
import { UITopNotificationType } from '../../notifications/UINotificationController.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { setElementOnClick } from '../../ui_utils/DomUtils.ts';
export var Rule = /*#__PURE__*/ function(Rule) {
    Rule[Rule["PrivateRoom"] = 0] = "PrivateRoom";
    Rule[Rule["HideBankCards"] = 1] = "HideBankCards";
    Rule[Rule["FriendlyRobber"] = 2] = "FriendlyRobber";
    Rule[Rule["BalancedDice"] = 3] = "BalancedDice";
    Rule[Rule["NoTrolls"] = 4] = "NoTrolls";
    return Rule;
}({});
export class UIRoomSettingsRulesController {
    load(roomState, rulesData) {
        this.roomState = roomState;
        this.rulesData = rulesData !== null && rulesData !== void 0 ? rulesData : new Map();
        const infoIcon = document.getElementById('room_center_rules_info_icon');
        const isTournamentRoom = this.roomState.isTournament;
        if (infoIcon != undefined) {
            setElementOnClick(infoIcon, ()=>{
                showRulesInfoDialog(isTournamentRoom);
            });
        }
        if (this.rulesSelector == undefined) {
            this.createRulesSelector();
            return;
        }
        this.updateRulesSelector();
    }
    update(newRoomState, rulesData) {
        const shouldUpdate = this.shouldUpdate(newRoomState);
        this.roomState = newRoomState;
        if (rulesData) this.rulesData = rulesData;
        if (shouldUpdate) this.updateRulesSelector();
    }
    updateInteractabilityOfElements(isGuest) {
        this.rulesSelector.updateInteractabilityOfElements(isGuest);
    }
    overrideRuleAvailableState(rule, available) {
        const ruleData = this.rulesData.get(rule);
        if (ruleData == undefined) return;
        ruleData.available = available;
        this.updateRulesSelector();
    }
    overrideRuleSelectedState(rule, selected) {
        const ruleData = this.rulesData.get(rule);
        if (ruleData == undefined) return;
        ruleData.selected = selected;
        this.updateRulesSelector();
    }
    createRulesSelector() {
        const rulesItemData = this.getRulesItemData();
        this.rulesSelector = new UIComponentItemScroll(this.container, rulesItemData, false);
    }
    updateRulesSelector() {
        const rulesItemData = this.getRulesItemData();
        this.rulesSelector.update(rulesItemData);
    }
    getRulesItemData() {
        var _this_rulesData_get, _this_rulesData_get1, _this_rulesData_get2;
        var _this_rulesData_get_selected, _this_rulesData_get_available, _this_rulesData_get_selected1;
        const rulesItemData = [
            {
                name: {
                    key: 'strings:roomPage.options.privateGame.title'
                },
                image: LobbyImage.PrivateGame,
                available: true,
                selected: (_this_rulesData_get_selected = (_this_rulesData_get = this.rulesData.get(0)) === null || _this_rulesData_get === void 0 ? void 0 : _this_rulesData_get.selected) !== null && _this_rulesData_get_selected !== void 0 ? _this_rulesData_get_selected : this.roomState.gameSetting.privateGame,
                canToggle: true,
                clickAction: ()=>this.onClickPrivateGame(),
                visible: !this.isTournamentRoom()
            },
            {
                name: {
                    key: 'strings:roomPage.options.hideBankCards.title'
                },
                image: LobbyImage.HideBankCards,
                available: true,
                selected: this.roomState.gameSetting.hideBankCards,
                canToggle: true,
                clickAction: ()=>this.onClickHideBankCards(),
                visible: true
            },
            {
                name: {
                    key: 'strings:roomPage.options.friendlyRobber.title'
                },
                image: LobbyImage.Robber,
                available: true,
                selected: this.roomState.gameSetting.friendlyRobber,
                canToggle: true,
                clickAction: ()=>this.onClickFriendlyRobber(),
                visible: true
            },
            {
                name: {
                    key: 'strings:roomPage.options.dice.titleMobile'
                },
                image: LobbyImage.Dice6,
                available: true,
                selected: this.roomState.gameSetting.diceSetting == DiceSettingEnum.Balanced,
                canToggle: true,
                clickAction: ()=>this.onClickBalancedDice(),
                visible: true
            },
            {
                name: {
                    key: 'strings:roomPage.options.noTrollsGame.title'
                },
                image: LobbyImage.IconNoTroll,
                available: (_this_rulesData_get_available = (_this_rulesData_get1 = this.rulesData.get(4)) === null || _this_rulesData_get1 === void 0 ? void 0 : _this_rulesData_get1.available) !== null && _this_rulesData_get_available !== void 0 ? _this_rulesData_get_available : !this.isNoTrollsDisabled(),
                selected: (_this_rulesData_get_selected1 = (_this_rulesData_get2 = this.rulesData.get(4)) === null || _this_rulesData_get2 === void 0 ? void 0 : _this_rulesData_get2.selected) !== null && _this_rulesData_get_selected1 !== void 0 ? _this_rulesData_get_selected1 : this.roomState.isNoTrollsGame(),
                canToggle: true,
                clickAction: ()=>this.onClickNoTrolls(),
                infoAction: ()=>this.sendNoTrollsNotification(),
                visible: !this.isTournamentRoom() && !UIUtilsEjsVariables.shouldHideStoreOnMobile
            },
            {
                name: {
                    key: 'strings:roomPage.orderSelection.title'
                },
                image: LobbyImage.ProfileRanked,
                available: true,
                selected: this.roomState.gameSetting.playOrderSelectionActive,
                canToggle: true,
                clickAction: ()=>socket.roomClient.togglePlayOrderSelection(),
                visible: this.isTournamentRoom()
            }
        ];
        return rulesItemData.filter((rule)=>rule.visible);
    }
    onClickPrivateGame() {
        var _this_rulesData_get;
        const onClick = (_this_rulesData_get = this.rulesData.get(0)) === null || _this_rulesData_get === void 0 ? void 0 : _this_rulesData_get.onClick;
        if (onClick != undefined) {
            onClick();
            return;
        }
        const newPrivateGame = !this.roomState.gameSetting.privateGame;
        socket.roomClient.setPrivateGame(newPrivateGame);
    }
    onClickHideBankCards() {
        const newHideBankCards = !this.roomState.gameSetting.hideBankCards;
        socket.roomClient.setHideBankCards(newHideBankCards);
    }
    onClickFriendlyRobber() {
        const isCurrentlyFriendlyRobber = this.roomState.gameSetting.friendlyRobber;
        socket.roomClient.setFriendlyRobber(!isCurrentlyFriendlyRobber);
    }
    onClickBalancedDice() {
        const isCurrentlyBalanced = this.roomState.gameSetting.diceSetting == DiceSettingEnum.Balanced;
        const newSetting = isCurrentlyBalanced ? DiceSettingEnum.Random : DiceSettingEnum.Balanced;
        socket.roomClient.setDiceType(newSetting);
    }
    onClickNoTrolls() {
        var _this_rulesData_get;
        const onClick = (_this_rulesData_get = this.rulesData.get(4)) === null || _this_rulesData_get === void 0 ? void 0 : _this_rulesData_get.onClick;
        if (onClick != undefined) {
            onClick();
            return;
        }
        socket.roomClient.toggleNoTrolls();
    }
    shouldUpdate(newRoomState) {
        if (this.roomState.hostSession.userId != newRoomState.hostSession.userId) return true;
        if (this.roomState.gameSetting.privateGame != newRoomState.gameSetting.privateGame) return true;
        if (this.roomState.gameSetting.hideBankCards != newRoomState.gameSetting.hideBankCards) return true;
        if (this.roomState.gameSetting.friendlyRobber != newRoomState.gameSetting.friendlyRobber) return true;
        if (this.roomState.gameSetting.diceSetting != newRoomState.gameSetting.diceSetting) return true;
        if (this.roomState.isNoTrollsGame() != newRoomState.isNoTrollsGame()) return true;
        if (this.roomState.gameSetting.playOrderSelectionActive != newRoomState.gameSetting.playOrderSelectionActive) return true;
        return false;
    }
    isTournamentRoom() {
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return false;
        return this.roomState.isTournament;
    }
    isNoTrollsDisabled() {
        if (!this.roomState.isHostSubscribed()) return true;
        if (this.roomState.isPrivateGame()) return true;
        return false;
    }
    sendNoTrollsNotification() {
        var _this_rulesData_get;
        const onInfoClick = (_this_rulesData_get = this.rulesData.get(4)) === null || _this_rulesData_get === void 0 ? void 0 : _this_rulesData_get.onInfoClick;
        if (onInfoClick != undefined) {
            onInfoClick();
            return;
        }
        const message = this.roomState.gameSetting.privateGame ? {
            key: 'strings:roomPage.notifications.noTrollsGameDisabledWhenPrivate'
        } : {
            key: 'strings:roomPage.options.noTrollsGame.becomeAMember'
        };
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) {
            notificationController.show(message, UITopNotificationType.Information, undefined, undefined, undefined, undefined, 3000);
            return;
        }
        notificationController.showNotification(LobbyImage.Lightning, message);
    }
    constructor(container){
        this.container = container;
    }
}
